import {
  addSeparatorFunction,
  calculateTimeUnitsFunction,
  clearAllIntervalsFunction,
  clearIntervalFunction,
  createTimeUnitFunction,
  initializeAllCountdownsFunction,
  initializeCountdownFunction,
  registerFunction,
  resetAllCountdownsFunction,
  setupGlobalListenersFunction,
} from './countdownScriptHelpers';

export const countdownScriptContent = (countdownId: string, showSeconds: boolean): string => `
if (!window.CountdownManager) {
  window.CountdownManager = {
    countdowns: {},
    intervals: {},
    initialized: false,
    
    createTimeUnit: ${createTimeUnitFunction},
    addSeparator: ${addSeparatorFunction},
    calculateTimeUnits: ${calculateTimeUnitsFunction},
    
    register: ${registerFunction},
    initializeCountdown: ${initializeCountdownFunction},
    clearInterval: ${clearIntervalFunction},
    clearAllIntervals: ${clearAllIntervalsFunction},
    initializeAllCountdowns: ${initializeAllCountdownsFunction},
    resetAllCountdowns: ${resetAllCountdownsFunction},
    setupGlobalListeners: ${setupGlobalListenersFunction}
  };
}

window.CountdownManager.register('${countdownId}', {
  showSeconds: ${showSeconds}
});
`;
